import validator from '@rjsf/validator-ajv8';
import { schema, uiSchema } from './formOptions.js';
import c from './ELNObjectEditor.module.css';
import { processAndSaveElnObject } from '../../../elnApi.js';
import Form from '@rjsf/mui';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { ValueWithUnit } from './fields/ValueWithUnit';
import { Toolbar, IconButton, Tooltip } from '@mui/material';
import FileCopy from '@mui/icons-material/FileCopy';

const fields = {
  ValueWithUnit: ValueWithUnit,
};

const log = (type) => console.log.bind(console, type);

export const ELNObjectEditor = ({ id, formData, setFormData, onSubmit, onCheck, onDuplicate }) => {
  return (
    <div className={c.ctr}>
      {/* Tool icon to duplicate */}
      <Toolbar>
        <Tooltip title="Duplicate">
          <IconButton onClick={() => { onDuplicate(id, formData) }}>
            <FileCopy />
          </IconButton>
        </Tooltip>
      </Toolbar>


      <span>{id ? `Editing Object ID: ${id}` : 'New ELN Object'}</span>
      <Form
        schema={schema}
        validator={validator}
        uiSchema={uiSchema}
        fields={fields}
        formData={formData}
        onChange={(e) => setFormData(e.formData)}
        onSubmit={(data) => {
          onSubmit(id, data.formData);
        }}
        onError={log('errors')}
      />
      <div className={c.buttonsCtr}>
        <Button variant="outlined" color="primary" onClick={() => onCheck(id, formData)}>
          Check
        </Button>
        <Button variant="contained" color="primary" onClick={() => onSubmit(id, formData)}>
          Save
        </Button>
      </div>
    </div>
  );
};
